import { Nullable } from "@data-force/app";
import { JobEntity, PhaseConfigNormalized } from "../../interfaces/store/actions/payload/job";
import StoreState from "../../interfaces/store/storeState";
import { Selector } from "./selectorType";

const selectSelectedJob: Selector<Nullable<JobEntity>> = (({job: {selectedJob}}: StoreState): Nullable<JobEntity> => selectedJob);

const selectPhaseConfigList: Selector<PhaseConfigNormalized> = (
    ({job: {phaseConfigList}}: StoreState): PhaseConfigNormalized => phaseConfigList);

const selectIsChromeExtensionMissingVisible: Selector<boolean> = (({
    job: {isChromeExtensionMissingVisible},
}: StoreState): boolean => isChromeExtensionMissingVisible);

export {
    selectIsChromeExtensionMissingVisible,
    selectPhaseConfigList,
    selectSelectedJob,
};
